import React from 'react';
import { SitemapView } from './sitemap-view';
import { useGlobalState } from '../global/context/global-context';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { useMenusData } from '../hooks/useMenusData';

export const SitemapFactory: React.FC = () => {
  const { applicationData } = useGlobalState();
  // Só os menus da entidade: os fixos da barra já estão nas seções estáticas do mapa
  const { menus } = useMenusData();

  return (
    <BaseLayoutFactory>
      <SitemapView
        entityName={applicationData?.entity?.nickName}
        menus={menus}
      />
    </BaseLayoutFactory>
  );
};
